import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAdd,
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCheckCircle,
  MdCloud,
  MdFolder,
  MdImage,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Login.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";
export default function Login({
  isMobile,
  email,
  setEmail,
  password,
  setPassword,
  user,
  setUser,
  username,
  setUsername,
}) {
  const [page, setPage] = useState("register");
  const [formFilled, setFormFilled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  useEffect(() => {
    if (!isEmpty(user)) {
      navigate("/");
    }
  }, [user]);

  const handleSignUp = async () => {
    if (!formFilled) {
      return;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("username", username);

    const response = await fetch(
      "https://www.cloud.ditochat.com/api/auth/signup.php",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.text();
    let resultParsed = JSON.parse(result);
    if (resultParsed.error) {
      alert(resultParsed.error);
    } else {
      setUser(resultParsed);
      saveToLocalStorage(result);
    }
    setIsLoading(false);
  };

  const handleLogin = async () => {
    if (!formFilled) {
      return;
    }
    setIsLoading(true);

    const formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);

    const response = await fetch(
      "https://www.cloud.ditochat.com/api/auth/login.php",
      {
        method: "POST",
        body: formData,
      }
    );

    const result = await response.text();
    let resultParsed = JSON.parse(result);
    if (resultParsed.error) {
      alert(resultParsed.error);
    } else {
      setUser(resultParsed);
      saveToLocalStorage(result);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      email.length > 4 &&
      password.length > 4 &&
      ((page == "register" && username.length > 4) || page != "register")
    ) {
      setFormFilled(true);
    } else {
      setFormFilled(false);
    }
  }, [email, password, username, page]);

  const saveToLocalStorage = (user_data) => {
    localStorage.setItem("@ditochat_user", user_data);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        if (formFilled && page == "register") {
          handleSignUp();
        } else if (formFilled && page != "register") {
          handleLogin();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    // Aufräumen beim Unmounten des Components:
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formFilled]);

  return (
    <div className="login">
      <div className="login_topnav">
        <div className="login_topnav_back" onClick={() => navigate("/")}>
          <ArrowBack /> Login
        </div>
      </div>
      <div className="login_secondtopnav">
        <div
          className={
            page == "login"
              ? "login_secondtopnav_left active"
              : "login_secondtopnav_left"
          }
          onClick={() => setPage("login")}>
          Einloggen
        </div>
        <div
          className={
            page == "register"
              ? "login_secondtopnav_right active"
              : "login_secondtopnav_right"
          }
          onClick={() => setPage("register")}>
          Neu Registrieren
        </div>
      </div>
      <div className="login_body">
        <input
          placeholder="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="login_body_input"
        />
        <input
          placeholder="password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="login_body_input"
        />
        {page == "register" && (
          <input
            placeholder="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="login_body_input"
          />
        )}

        {isLoading ? (
          <div className={"login_body_ctaOff"}>
            <Spinner />
          </div>
        ) : (
          <>
            {page == "register" ? (
              <div
                className={formFilled ? "login_body_cta" : "login_body_ctaOff"}
                onClick={() =>
                  formFilled ? handleSignUp() : alert("Fülle alle Felder aus")
                }>
                Registrieren
              </div>
            ) : (
              <div
                className={formFilled ? "login_body_cta" : "login_body_ctaOff"}
                onClick={() =>
                  formFilled ? handleLogin() : alert("Fülle alle Felder aus")
                }>
                Einloggen
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ImgIcon = styled(MdImage)`
  font-size: 25px;
  color: #474747;
`;

const CloudIcon = styled(MdCloud)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 18px;
  color: #474747;
  margin-bottom: -3px;
`;
